// /no-access (Parte 14.7, regra 2): sem contexto e sem rede — mensagem, "Minha conta" e sair.
import { PageHeader } from '@giyus/patterns';
import { Button } from '@giyus/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { useAuth } from '../lib/auth/authContext';
import { ROUTES } from '../lib/context/contextResolver';

export function NoAccessPage() {
  const { t } = useTranslation(['shell', 'common']);
  const { signOut } = useAuth();
  return (
    <section className="mx-auto flex max-w-xl flex-col items-start gap-5" data-testid="no-access">
      <PageHeader
        eyebrow="Acesso"
        title={t('shell:context.noAccessTitle')}
        description={t('shell:context.noAccessMessage')}
      />
      <p className="text-body text-muted-foreground">{t('shell:context.noAccessHelp')}</p>
      <div className="flex gap-2">
        <Button asChild variant="outline">
          <Link to={ROUTES.account}>{t('shell:nav.account')}</Link>
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            void signOut();
          }}
        >
          {t('common:actions.signOut')}
        </Button>
      </div>
    </section>
  );
}
